import { useMemo } from 'react';
import '../../styles/ArchiveBrigadeComposition.css';
import Table from '../Table/Table';
import { defaultCellRender } from '../../utils/formatValueForHTML';

/**
 * Компонент для отображения состава бригады на вкладке Архив.
 */

function ArchiveBrigadeComposition({ currentSession, t }) {
  // Колонки таблицы
  const columns = useMemo(
    () => [
      {
        Header: t?.type || 'Тип',
        accessor: 'type',
        Cell: ({ value }) => defaultCellRender(value),
      },
      {
        Header: t?.deviceId || 'ID устройства',
        accessor: 'id',
        Cell: ({ value }) => defaultCellRender(value),
      },
      {
        Header: t?.status || 'Статус',
        accessor: 'online',
        Cell: ({ value }) => defaultCellRender(value ? 'Активно' : 'Неактивно'),
      },
      {
        Header: t?.location || 'Место',
        accessor: 'inZone',
        Cell: ({ value, row }) => defaultCellRender(row.original.type === 'ИУ' ? (value ? 'В зоне' : 'Вне зоны') : '-'),
      },
      {
        Header: t?.condition || 'Состояние',
        accessor: 'viable',
        Cell: ({ value }) =>
          defaultCellRender(typeof value === 'boolean' ? (value ? 'Исправно' : 'Неисправно') : value),
      },
      {
        Header: t?.battery || 'Заряд',
        accessor: 'battery',
        Cell: ({ value }) => defaultCellRender(value),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentSession]
  );

  return (
    <div className="archive-brigade-composition">
      <div className="archive-brigade-composition_table-container">
        <Table data={currentSession?.composition || []} columns={columns} />
      </div>
    </div>
  );
}

export default ArchiveBrigadeComposition;
